import { createSelector } from 'reselect';

export const getCallListsById = state => state.callLists.callLists || {};
export const getTargetContactIds = state => state.callLists.contactIds || [];
export const getTargetListId = state => state.callLists.targetListId;
export const isAddingContactsToList = state => !!state.callLists.isAddingContactsToList;

export const getCallLists = createSelector(
  [getCallListsById],
  callLists => Object.values(callLists)
);

export const getTargetList = createSelector(
  [getCallListsById, getTargetListId],
  (callLists, targetListId) => callLists[targetListId]
);
